import React from 'react'

const RoundTickIcon = ({ color = '#000', className = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 15.4 15.4">
      <g data-name="tick-circle-svgrepo-com (5)">
        <path
          data-name="Path 937"
          d="M9 16a7 7 0 1 0-7-7 7.021 7.021 0 0 0 7 7z"
          style={{
            fill: 'none',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '1.4px',
          }}
          transform="translate(-1.3 -1.3)"
        />
        <path
          data-name="Path 938"
          d="m7.75 11.691 2.371 2.521L14.87 9.17"
          transform="translate(-3.61 -3.992)"
          style={{
            fill: 'none',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '1.4px',
          }}
        />
      </g>
    </svg>
  )
}

export default RoundTickIcon
